<template>
  <div>
    <el-form :model="form" :rules="rules" label-width="120px" ref="form" style="margin-bottom:80px" v-loading="pageloading">
      <el-card header="淘客订单收益配置">
        <el-form-item label="消费者下单省：" prop="SelfMarketIncomeRate" :rules="rules.SelfMarketIncomeRate">
          <el-input style="width:140px" placeholder="0" v-model="form.SelfMarketIncomeRate"
            oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"></el-input>
          <span class="margin-left-10">%</span>
        </el-form-item>
        <el-form-item label="推手收益：">
          <el-table :data="form.list" style="width:650px">
            <el-table-column prop="AgentRoleName" label="级别" width="150"></el-table-column>
            <el-table-column prop="" label="推手收益">
              <template slot-scope="scope">
                <el-form-item label-width="0px" :prop="'list.'+scope.$index+'.SelfMarketIncomeRate'" :rules="rules.SelfMarketIncomeRate" style="margin:20px 0px">
                  <el-input style="width:140px" placeholder="0" v-model="scope.row.SelfMarketIncomeRate"
                    oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="" label="">
              <template slot-scope="scope" slot="header">
                <div class="flex flex-align-center">
                  <div>直推收益</div>
                  <el-popover placement="top" width="200" trigger="hover" content="A推荐B，B每获得1元推手收益，A可得N个积分">
                    <i slot="reference" class="el-icon-warning-outline font-16 margin-left-5"></i>
                  </el-popover>
                </div>
              </template>
              <template slot-scope="scope">
                <el-form-item label-width="0px" :prop="'list.'+scope.$index+'.RecommendIncomePoint'" :rules="rules.RecommendIncomePoint" style="margin:20px 0px">
                  <el-input style="width:140px" placeholder="0" v-model="scope.row.RecommendIncomePoint"
                    onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                    onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                    <template slot="append">积分</template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-card>
    </el-form>

    <el-card class="bottom-save-btn">
			<el-button type="primary" @click="submitForm('form')">保存</el-button>
		</el-card>
  </div>
</template>

<script>
import {
  taoKeOrderIncomeConfiginit,
  taoKeOrderIncomeConfigsave
} from "@/api/sv3.0.0"
export default {
  data () {
    return {
      pageloading:false,
      form:{
        SelfMarketIncomeRate:'',
        consumer:{
          SelfMarketIncomeRate:'',
        },
        list:[]
      },
      rules:{
        SelfMarketIncomeRate:[{
          validator: (rule, value, callback)=>{
            if(String(value)){
              if(value<0||value>100){
                callback(new Error('请设置正确的百分比'))
              }
            }
            callback()
          },
          trigger: 'blur',
        }],
        SelfMarketIncomeRate:[{
          validator: (rule, value, callback)=>{
            if(String(value)){
              if(value<0||value>100){
                callback(new Error('请设置正确的百分比'))
              }
            }
            if(rule.fullField.split('.').length>1){
              let num = rule.fullField.split('.')[1]
              if(num > 0){
                let last = this.form.list[Number(num)-1]
                console.log(last)
                if(last && value < Number(last.SelfMarketIncomeRate)){
                  callback(new Error('收益需大于等于低级别推手'))
                }
              }
              // if(this.form.list[num].AgentRoleGradeNum==1){
              //   let allScale = this.form.list.filter(v=>v.AgentRoleGradeNum!=1).reduce((c,v)=>{
              //     return c += Number(v.SelfMarketIncomeRate)
              //   },0)
              //   if(allScale>value){
              //     callback(new Error('最高级别收益需大于等于其他级别收益之和'))
              //   }
              // }
            }
            callback()
          },
          trigger: 'blur',
        }],
        RecommendIncomePoint:[{
          validator: (rule, value, callback)=>{
            if(String(value)){
              if(value<0||value>99999){
                callback(new Error('积分请设置在0-99999之间'))
              }
            }
            callback()
          },
          trigger: 'blur',
        }],
      }
    }
  },
  mounted () {
    this.getInfo()
  },
  methods:{
    async getInfo(){
      try{
        this.pageloading = true
        let res = await taoKeOrderIncomeConfiginit()
        if(res.IsSuccess){
          res.Result = res.Result.map(v=>{
            if(v.Id==0){
              v.RecommendIncomePoint = v.RecommendIncomePoint||''
              v.SelfMarketIncomeRate = v.SelfMarketIncomeRate||''
            }
            return v
          })
          let form = JSON.parse(JSON.stringify(this.form))
          let consumer = res.Result.find(v=>v.AgentRoleId==0)
          if(consumer){
            form.SelfMarketIncomeRate = consumer.SelfMarketIncomeRate
            form.consumer = consumer
          }
          form.list = res.Result.filter(v=>v.AgentRoleId!=0)
          this.form = JSON.parse(JSON.stringify(form))
        }
      }finally{
        this.pageloading = false
      }
    },
    submitForm(formName){
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try{
            this.pageloading = true
            let form = JSON.parse(JSON.stringify(this.form))
            form.list.push({
              ...form.consumer,
              SelfMarketIncomeRate:form.SelfMarketIncomeRate
            })
            let res = await taoKeOrderIncomeConfigsave({taoKeOrderIncomeConfigDtos:form.list})
            if(res.IsSuccess){
              this.$message.success('保存成功')
              this.getInfo()
            }
          }finally{
            this.pageloading = false
          }
        } else {
          this.$nextTick(()=>{
            const element = document.querySelectorAll('.el-form-item__error')[0]
            element.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'center' 
            }) 
          })
          return false;
        }
      });
    }
  }
}
</script>

<style lang='less' scoped>
.bottom-save-btn {
  position: absolute;
  width: 100%;
  background: #fff;
  bottom: 0;
  right: 0;
  left: 0;
  height: 80px;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10%;
}
</style>